import React from 'react';
import Hero from '../Hero';
import { useEffect, useState } from 'react';
import AboutSection from '../Section/AboutSection';
import Banner from '../Section/BannerSection';
import Section from '../Section';
import FeaturesSection from '../Section/FeaturesSection';
import TestimonialSection from '../Section/TestimonialSection';
import BlogSection from '../Section/BlogSection';
import AppointmentSection from '../Section/AppointmentSection';
import FaqSection from '../Section/FaqSection';
import DepartmentSection from '../Section/DepartmentSection';
import { pageTitle } from '../../helpers/PageTitle';
import { getLandingPageBySlug, getBlog } from '../../service/api';
import { previewAssetUrl } from '../../helpers';
import dayjs from 'dayjs';

export default function Home() {
  const [data, setData] = useState(null);
  const [blogData, setBlogData] = useState([]);

  const fetchData = async () => {
    try {
      const data = await getLandingPageBySlug('home');
      setData(data);
    } catch (error) {
      console.error('Error fetching landing page:', error);
    }
  };

  const fetchBlog = async () => {
    try {
      const res = await getBlog({
        filter: {},
        page: 1,
        limit: 3,
        sort: { createdAt: '-1' },
      });
      setBlogData(
        res?.data?.docs.map((item) => ({
          title: item.title,
          thumbUrl: previewAssetUrl(item.assetId),
          date: dayjs(item.createdAt).format('DD/MM/YYYY'),
          btnText: 'Xem thêm',
          href: `/blog/${item.id}`,
          socialShare: true,
        }))
      );
    } catch (err) {
      setBlogData([]);
    }
  };

  const content = data?.content;

  useEffect(() => {
    fetchData();
    fetchBlog();
  }, []);

  pageTitle('Home');

  return (
    <>
      <Hero
        title={content?.introduction?.title || ''}
        subTitle={content?.introduction?.content || ''}
        bgUrl='/images/home_1/hero_bg.jpeg'
        imgUrl={
          content?.introduction?.bannerId
            ? previewAssetUrl(content.introduction.bannerId)
            : '/images/home_1/hero_img.png'
        }
        videoBtnText='Xem chúng tôi làm việc'
        videoUrl={content?.introduction?.link || ''}
        // infoList={[
        //   {
        //     title: 'Hotline',
        //     subTitle: '123-456-7890',
        //     iconUrl: '/images/contact/icon_1.svg',
        //   },
        //   {
        //     title: 'Ambulance',
        //     subTitle: '876-256-876',
        //     iconUrl: '/images/icons/ambulance.svg',
        //   },
        //   {
        //     title: 'Location',
        //     subTitle: 'New York, US',
        //     iconUrl: '/images/icons/pin.svg',
        //   },
        // ]}
        infoList={content?.introduction?.contact?.map((item) => ({
          title: item?.title,
          subTitle: item?.content,
          iconUrl: previewAssetUrl(item?.iconId),
        }))}
        btnText='Đặt lịch ngay'
        btnUrl='#appointment'
      />
      {/* Start Feature Section */}
      <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={185}
        bottomLg={140}
        bottomXl={100}
      >
        <FeaturesSection
          sectionTitle='Giá trị của chúng tôi'
          data={content?.ourValues?.map((item) => ({
            title: item?.title,
            subTitle: item?.content,
            iconSrc: previewAssetUrl(item?.iconId),
          }))}
        />
      </Section>
      {/* End Feature Section */}
      {/* Start About Section */}
      <Section>
        <AboutSection
          imgUrl={
            previewAssetUrl(content?.aboutUs?.bannerId) ||
            '/images/home_1/about.png'
          }
          spiningImgUrl='/images/home_1/about_mini.svg'
          title='Về chúng tôi'
          subTitle={content?.aboutUs?.title || ''}
          featureList={[
            {
              featureListTitle: `${content?.aboutUs?.subTitle || ''}`,

              featureListSubTitle: `${content?.aboutUs?.content || ''}`,
            },
          ]}
        />
      </Section>
      {/* End About Section */}
      {/* Start Departments Section */}
      <Section topMd={185} topLg={150} topXl={110}>
        <DepartmentSection
          sectionTitle='Phòng ban'
          bgUrl='images/home_1/department_bg.svg'
          data={content?.departments?.map((item) => ({
            title: item?.title,
            iconUrl: previewAssetUrl(item?.iconId),
          }))}
        />
      </Section>

      {/* End Departments Section */}
      {/* Start Award Section */}
      {/* <Section topMd={185} topLg={140} topXl={100}>
        <AwardSection sectionTitle='Departments' data={awardData} />
      </Section> */}
      {/* End Award Section */}
      {/* Start Testimonial */}
      <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <TestimonialSection
          sectionTitle='Một số đánh giá'
          sectionTitleDown='Của khách hàng chúng tôi'
          data={content?.reviews?.map((item) => ({
            name: item?.name,
            address: item?.address,
            avatar: previewAssetUrl(item?.avatarId),
            content: item?.content,
          }))}
        />
      </Section>
      {/* End Testimonial */}
      {/* Start Banner Section */}
      <Section>
        <Banner
          bgUrl='images/home_1/cta_bg.svg'
          imgUrl={previewAssetUrl(content?.subBanner?.bannerId) || ''}
          title={content?.subBanner?.title || ''}
          subTitle={content?.subBanner?.content || ''}
        />
      </Section>
      {/* End Banner Section */}
      {/* Start Blog Section */}
      <Section topMd={190} topLg={145} topXl={105}>
        <BlogSection sectionTitle='Bài viết mới nhất' data={blogData} />
      </Section>
      {/* End Blog Section */}
      {/* Start Appointment Section */}
      <Section topMd={190} topLg={145} topXl={105} id='appointment'>
        <AppointmentSection
          sectionTitle='Đặt lịch ngay'
          sectionTitleUp='ĐẶT LỊCH'
          imgUrl={previewAssetUrl(content?.appointment?.bannerId) || ''}
        />
      </Section>
      {/* End Appointment Section */}
      {/* Start FAQ Section */}
      <Section topMd={190} topLg={145} topXl={105}>
        <FaqSection
          data={content?.qa?.map((item) => ({
            title: item?.question,
            content: item?.answer,
          }))}
          sectionTitle='Câu hỏi thường gặp'
        />
      </Section>
      {/* End FAQ Section */}
      {/* Start Brand Section */}
      {/* <Section
        topMd={200}
        topLg={150}
        topXl={110}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <BrandsSection data={brandData} />
      </Section> */}
      {/* End Brand Section */}
    </>
  );
}
